import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "./components/HomePage";
import Quiz from "./components/Quiz";
import QuizResults from "./components/QuizResults";
import GetStarted from "./components/GetStarted";
import BookCall from "./components/BookCall";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return <HomePage />;
};

const QuizPage = () => {
  const [quizResults, setQuizResults] = useState(null);

  const handleQuizComplete = (results) => {
    setQuizResults(results);
  };

  const handleGetStarted = () => {
    // Navigate to get started flow
    window.location.href = '/get-started';
  };

  const handleBookCall = () => {
    // Navigate to strategy call booking page
    window.location.href = '/book-call';
  };

  if (quizResults) {
    return (
      <QuizResults 
        results={quizResults}
        onGetStarted={handleGetStarted}
        onBookCall={handleBookCall}
      />
    );
  }

  return <Quiz onComplete={handleQuizComplete} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/book-call" element={<BookCall />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;